// extracted by mini-css-extract-plugin
export var divider = "_3u-0";
export var dividerText = "_3u-1";